import { render, staticRenderFns } from "./ReferralTable.vue?vue&type=template&id=61c924fa&"
import script from "./ReferralTable.vue?vue&type=script&lang=js&"
export * from "./ReferralTable.vue?vue&type=script&lang=js&"
import style0 from "./ReferralTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports